import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-gradient-card',
    templateUrl: './gradient-card.component.html',
    styleUrls: ['./gradient-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GradientCardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
